<form *ngIf="showInlandsAdresse" [formGroup]="form" autocomplete="off" class="form-horizontal">

    <div class="form-row">
        <label class="d-sm-none col-form-label" for="inlandsadresseStrasse{{index}}">
            {{ 'COMMON_UI.ADRESSEN.INLANDSADRESSE.STRASSE' | translate }}
        </label>
        <label class="d-none d-sm-inline col-sm-4 col-form-label">
            {{ 'COMMON_UI.ADRESSEN.INLANDSADRESSE.STR_HNR_ZUS' | translate }}
        </label>
        <div class="col-sm-4">
            <input
                    type="text"
                    class="form-control" datevMessagePath="inlandsadresseStrasse{{objectId}}" formControlName="strasse"
                    id="inlandsadresseStrasse{{index}}"
                    utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
        </div>

        <label class="d-sm-none col-form-label"
               for="inlandsadresseHausnummer{{index}}">{{ 'COMMON_UI.ADRESSEN.INLANDSADRESSE.HAUSNUMMER' | translate }}</label>
        <div class="col-sm-2">
            <input
                    type="text"
                    numeric
                    id="inlandsadresseHausnummer{{index}}"
                    class="form-control"
                    formControlName="hausnummer"
                    datevMessagePath="inlandsadresseHausnummer{{objectId}}"
                    data-eric-id="Inhaber[1]/NNatPers[1]/Adrkette[1]/StrAdr[1]/HausNr[1]"
                    utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
        </div>

        <label class="d-sm-none col-form-label"
               for="inlandsadresseHausnummernzusatz{{index}}">{{ 'COMMON_UI.ADRESSEN.INLANDSADRESSE.HAUSNUMMERNZUSATZ' | translate }}</label>
        <div class="col-sm-2">
            <input class="form-control" datevMessagePath="inlandsadresseHausnummernzusatz{{objectId}}"
                   formControlName="hausnummernzusatz"
                   id="inlandsadresseHausnummernzusatz{{index}}"
                   type="text" utilsCheckValidity
                   utilsControlState utilsValidationMessage/>
        </div>
    </div>

    <div class="form-row">
        <label class="col-sm-4 col-form-label"
               for="inlandsadresseAdressergaenzung{{index}}">{{ 'COMMON_UI.ADRESSEN.INLANDSADRESSE.ADRESSERGAENZUNG' | translate }}</label>
        <div class="col-sm-8">
            <input class="form-control" datevMessagePath="inlandsadresseAdressergaenzung{{objectId}}"
                   formControlName="adressergaenzung"
                   id="inlandsadresseAdressergaenzung{{index}}"
                   type="text" utilsCheckValidity
                   utilsControlState utilsValidationMessage/>
        </div>
    </div>

    <div class="form-row">
        <label class="d-sm-none col-form-label"
               for="inlandsadressePostleitzahl{{index}}">{{ 'COMMON_UI.ADRESSEN.INLANDSADRESSE.PLZ' | translate }}</label>
        <label *ngIf="inlandOrtLocalzation" class="d-none d-sm-inline col-sm-4 col-form-label">
            {{ inlandOrtLocalzation }}
        </label>
        <label *ngIf="!inlandOrtLocalzation" class="d-none d-sm-inline col-sm-4 col-form-label">
            {{ 'COMMON_UI.ADRESSEN.INLANDSADRESSE.PLZ_ORT' | translate }}
        </label>
        <div class="col-sm-2">
            <input
                    type="text"
                    id="inlandsadressePostleitzahl{{index}}"
                    class="form-control"
                    formControlName="postleitzahl"
                    datevMessagePath="inlandsadressePostleitzahl{{objectId}}"
                    data-eric-id="Inhaber[1]/NNatPers[1]/Adrkette[1]/StrAdr[1]/Plz[1]
                                    Betrieb[1]/BetriebsstaettenListe[1]/Betriebsstaette[?]/Adrkette[1]/StrAdr[1]/Plz[1]
                                  "
                    utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
        </div>

        <label class="d-sm-none col-form-label"
               for="inlandsadresseOrt{{index}}">{{ 'COMMON_UI.ADRESSEN.INLANDSADRESSE.ORT' | translate }}</label>
        <div class="col-sm-6">
            <input class="form-control" datevMessagePath="inlandsadresseOrt{{objectId}}" formControlName="ort"
                   id="inlandsadresseOrt{{index}}" type="text"
                   utilsCheckValidity utilsControlState utilsMarkRequired
                   utilsValidationMessage/>
        </div>
    </div>

</form>
